<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 invwc stick">
                        <div class="row comifo myma lnhn pb-3 pt-2">
                            <div class="col-2 xtc" id="u_pic"><span class="avatar"></span></div>
                            <div class="col-10 xtl">
                                <div class="tf-18"><span id="u_nam">{{ this.userdetails.nickname }}</span></div>
                                <div class="tf-12 pt-1">Mob:<span id="u_mob">{{ this.userdetails.username }}</span>,
                                    ID:<span id="u_id">{{ this.userdetails.id }}</span></div>
                            </div>
                            <div class="col-12 pt-2 ddavc">
                                <div class="srm67b cnn" @click="changebox('nickname')">Change Nick Name</div>
                                <div class="srm67b cnn" @click="changebox('password')">Change Password</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pa-0 pb-4 mt-4 mb-56 tf-16">
                        <div class="row mr-0 mt-4 pt-2 xtl pl-3 pr-3 bdb6p">
                            <div class="col-12 pl-0 pr-2 pt-3 pb-3 inbdb" onclick="window.location.href='#/orderrecord?server=FastParity'"><span
                                    class="odhis"></span><span class="lnhfk">Order Record</span><span
                                    class="arrow-right"></span></div>
                            <div class="col-12 pl-0 pr-2 pt-3 pb-3" onclick="window.location.href='#/dairy'"><span class="fdwal"></span><span
                                    class="lnhfk">Financial Details</span><span class="arrow-right"></span></div>
                        </div>
                        <div class="row mr-0 xtl pl-3 pr-3 bdb6p">
                            <div class="col-12 pl-0 pr-2 pt-3 pb-3 inbdb" ><a target="_self" href="/App.apk"
          download="App.apk"><span
                                    class="down"></span><span class="lnhfk">Download</span><span
                                    class="arrow-right"></span></a></div>
                            <div class="col-12 pl-0 pr-2 pt-3 pb-3 inbdb"  onclick="window.location.href='https://t.me/official0076'" ><span
                                    class="follow"></span><span class="lnhfk">Follow us</span><span
                                    class="arrow-right"></span></div>
                            <div class="col-12 pl-0 pr-2 pt-3 pb-3"  onclick="window.location.href='https://t.me/telegram_here'" ><span class="support"></span><span
                                    class="lnhfk">Support</span><span class="arrow-right"></span></div>
                        </div>
                        <div class="row mr-0 mt-4">
                            <div class="col-12 xtc pt-3 pb-3 unLine mcpl" @click="logout()">Sign Out</div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>

                <div class="row" id="footer">
                    <div class="col-12 nav-bar adsob" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem" id="moxht2b4u" onclick="window.location.href='#/'">
                                    <div class="xtc"><span class="icon home" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="raeiyf2m0" onclick="window.location.href='#/promotion'">
                                    <div class="xtc"><span class="icon group" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="sfrm6bvy" onclick="window.location.href='#/recharge'">
                                    <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="mcpnvd2my" onclick="window.location.href='#/mine'">
                                    <div class="xtc"><span class="icon my sel" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">

                </div>
                <div class="row" id="dta_ref">
                    <div class="col-12 conod" id="clink" style="display:none;">
                        
                        <div class="tffm ssmg rc fadein03" id="change" style="display:none;">
                            <div class="tf-18 tfw-6 tfcdb">{{this.changetext}}</div>
                            <div class="inpbcx tfcb"><input class="xbox" v-model="change" :placeholder="[[this.changetext1]]" >
                            </div>
                            <div class="row xtc">
                                <div class="col-6 pr-1">
                                    <div class="btn-con rc" @click="cancel()">Cancel</div>
                                </div>
                                <div class="col-6 pl-1">
                                    <div class="btn-main act" @click="confirmchange()">Confirm</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 conod LR" id="msgbox" @click="remove()" style="display:none;">   
                        <div class="ssmg fadein" id="msg"  ><div class="tf-14 pb-2"></div></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
    name: "MineView",
    data() {
        return {
            changename:null,
            changetext:null,
            changetext1:null,
            change:null,
            userdetails: {
                id: null,
                nickname: null,
                username: null,
                balance: null,
                usercode: null,
                commision: "0",
                intrest: "0",
                notice: "Welcome",

            },
            user: [],
            dailysign: []
        }

    },
    beforeCreate: function () {
        if (localStorage.getItem('username') == null) {
            this.$router.push({ name: 'login' });
        }

    },
    created: function () {
      


    },
    mounted: function () {
        this.getUserdetails();
    },
    


    methods: {
        pop(message) {
            document.getElementById("msg").innerHTML = message;
            document.getElementById("msgbox").style.display = "";
            setTimeout(this.getUserdetails(),1500);
        },
        changebox(name){
            document.getElementById("clink").style.display = "";
            document.getElementById("change").style.display = "";
            if(name=='nickname'){
                this.changename='nickname';
                this.changetext='Change Nick Name';
                this.changetext1='Enter Nick Name';
            }else if(name=='password'){  
                this.changename='password';
                this.changetext='Set New Password';
                this.changetext1='New Password';
            }
        },
        cancel(){
            document.getElementById("clink").style.display = "none";
            this.change=null;
        },
        confirmchange(){
            
            if(this.changename=='nickname'){
                if(this.change==null){
                    this.pop("Enter Your Name");
                    this.cancel();
                }else{
                    axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=changenickname&user=' + this.userdetails.username +'&nickname='+this.change);
                  
                    this.pop("Successfully");
                    this.cancel();
                    
                }
            }else if(this.changename=='password'){
                if(this.change==null){
                    this.pop("Please Enter Password");
                    this.cancel();
                }else{
                    axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=changepassword&user=' + this.userdetails.username +'&password='+this.change);
                    
                    this.pop("Successfully");
                    this.cancel();
                }
            }
        },
        remove(){
            document.getElementById("msgbox").style.display = "none";
            this.getUserdetails();
        },
        logout() {
            localStorage.removeItem('username')
            this.$router.push("/login");
        },
  
       
      
        getUserdetails() {

            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.userdetails.username).then((res) => {
                this.Users = res.data.user_Data;
                this.userdetails.id = this.Users[0].id;
                this.userdetails.balance = this.Users[0].balance;
                this.userdetails.usercode = this.Users[0].usercode;
                this.userdetails.nickname = this.Users[0].nickname;
            }).catch((err) => {
                console.log(err);
            })



        }
    }

}
</script>